import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { translations } from '../translations'
import { ItemData, Type } from '../types'
import { PropContainer } from './PropContainer'

interface Props {
  item: ItemData
  type: Type
}

export const Item = ({ item, type }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box
      background="grey000White"
      padding="s4"
      borderRadius={{ all: 'abs008' }}
      onClick={(ev) => {
        ev.stopPropagation()

        if (item.contractVersionId) {
          navigate(
            navigation.employees.id.contractVersions.contractVersionId.fullPath({
              id: item.employeeId,
              contractVersionId: item.contractVersionId,
            })
          )
        } else {
          navigate(navigation.employees.id.contractVersions.fullPath({ id: item.employeeId }))
        }
      }}
    >
      <Box padding="s8" paddingBottom="s0">
        <Text.Normal size="200" weight="medium">
          {translations({
            type,
            employeeName: <PropContainer>{item.employeeName}</PropContainer>,
            date: <PropContainer>{item.date}</PropContainer>,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}
